// extracted by mini-css-extract-plugin
export var container = "FeatureItem-module--container--2fa0e";
export var imageWrapper = "FeatureItem-module--image-wrapper--4490f";
export var textWrapper = "FeatureItem-module--text-wrapper--0a865";